// The DOM entry to the device database. Vite only recognises a worker when new URL(...)
// is written literally inside new Worker(...) with static options, so this stays here and
// the platform-neutral client lives in ./client.
import { createDbClient, type DbClient, type DbClientOptions, type TokenProvider } from './client'

export type { DbClient, DbClientOptions, TokenProvider }

export function openDbWorker(): Worker {
  // Legacy worker name from SIMU; kept with the database's other names (test/nama-warisan.test.ts).
  return new Worker(new URL('./worker.ts', import.meta.url), { type: 'module', name: 'simu-db' })
}

/** Take the tab lock, start the worker and return the client; await `client.ready`. */
export function openDb(options: Omit<DbClientOptions, 'createWorker'> = {}): DbClient {
  return createDbClient({ ...options, createWorker: openDbWorker })
}
